import { createSlice } from '@reduxjs/toolkit';

const simpleModal = createSlice({
  name: 'simpleModal',
  initialState: '',
  reducers: {
    showModal: (state, action) => {
      return action.payload;
    },
    hideModal: state => {
      return '';
    }
  }
});
export const { showModal, hideModal } = simpleModal.actions;
export default simpleModal;
